import { Provider } from '@angular/core';

import { EXPORTERS } from './tokens/exporter.tokens';
import { CsvExporter } from './exporters/csv.exporter';
import { XlsxExporter } from './exporters/xlsx.exporter';
import { AgentJsonExporter } from './exporters/agent-json.exporter';
import { JiraExporter } from './exporters/jira.exporter';
import { GitlabExporter } from './exporters/gitlab.exporter';

/**
 * Entry point ÚNICO de registro de exporters.
 *
 * Convención: cualquier exporter nuevo (XLSX, MCP, Jira, GitLab, …) se añade
 * a ESTE archivo. El consumidor (app.module.ts) usa `...provideExports()`
 * UNA sola vez en su `providers` y no necesita volver a tocarse después.
 *
 * Pattern:
 *   - Cada exporter `@Injectable({ providedIn: 'root' })` se lista para que
 *     Angular lo conozca y no haga tree-shake.
 *   - Cada exporter se registra como multi-provider del token EXPORTERS
 *     vía `useExisting`, de modo que el ExportService los reciba como array
 *     y compartan instancia con cualquier consumidor directo.
 */
export function provideExports(): Provider[] {
  return [
    // CSV (Punto 3) — síncrono, cliente.
    CsvExporter,
    { provide: EXPORTERS, useExisting: CsvExporter, multi: true },

    // XLSX (Punto 4) — síncrono, cliente, ExcelJS lazy.
    XlsxExporter,
    { provide: EXPORTERS, useExisting: XlsxExporter, multi: true },

    // Agent JSON (Punto 5) — síncrono, cliente, bundle MCP-ready.
    AgentJsonExporter,
    { provide: EXPORTERS, useExisting: AgentJsonExporter, multi: true },

    // Jira (Punto 7) — asíncrono, push backend, OAuth 3LO.
    JiraExporter,
    { provide: EXPORTERS, useExisting: JiraExporter, multi: true },

    // GitLab (Punto 9) — asíncrono, push backend, OAuth PKCE.
    GitlabExporter,
    { provide: EXPORTERS, useExisting: GitlabExporter, multi: true }
  ];
}
